import React from 'react';
import { ventures } from '../data/ventures';
import { Wordmark } from './Wordmark';
export function LogoWall() {
  return <section aria-label="Companies founded and co-founded" className="border-b border-rule bg-paper-alt" data-id="element-45" data-mp="62p2d7ihrr0d">
      <div className="mx-auto max-w-page px-6 py-10 lg:px-10 lg:py-12" data-id="element-46" data-mp="3ohhhec3vjhqp">
        <p className="font-sans text-[12px] uppercase tracking-overline text-muted" data-id="element-47" data-mp="3sgqbxj6qnjnb">
          Founded, co-founded &amp; governed — {ventures.length} ventures since 2011
        </p>

        <ul className="mt-8 grid grid-cols-2 gap-x-8 gap-y-9 sm:grid-cols-3 lg:grid-cols-5" data-id="element-48" data-mp="p0j9th3z1ugn">
          {ventures.map(venture => <li key={venture.id} data-id="element-49" data-mp="b08fg43gdxqq">
              <a href={venture.href ?? '#ventures'} target={venture.href ? '_blank' : undefined} rel={venture.href ? 'noreferrer' : undefined} className="group flex h-full flex-col justify-between text-muted transition-colors duration-200 ease-out hover:text-ink focus-visible:text-ink focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-4 focus-visible:ring-offset-paper-alt" data-id="element-50" data-mp="b3cpvj7ihppu">
                <span className="flex min-h-[34px] items-center" data-id="element-51" data-mp="22hzj2atcuze1">
                  <Wordmark name={venture.name} mark={venture.mark} data-id="element-52" data-mp="2hegvz6h70m2p" />
                </span>
                <span className="mt-3 block font-sans text-[11px] uppercase tracking-[0.14em] text-muted/70 opacity-0 transition-opacity duration-200 ease-out group-hover:opacity-100 group-focus-visible:opacity-100" data-id="element-53" data-mp="2ccztj6j28rk0">
                  {venture.years}
                </span>
              </a>
            </li>)}
        </ul>
      </div>
    </section>;
}